import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/shared/services/request/request.service';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskService } from 'src/app/shared/services/task/task.service';
import { ExpertService } from 'src/app/shared/services/expert/expert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-boiling-point',
  templateUrl: './boiling-point.component.html',
  styleUrls: ['./boiling-point.component.less']
})
export class BoilingPointComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    if(this.expertClassificationMode){
      this.expertService.getExpertData$.subscribe((data: any) => {
        if (data) {
          this.expertService.sendPhysicalData({ type: "boiling_point", form: data.boiling_point, treeData: data });
        }
      });
    }
  }

  constructor(
    public route: ActivatedRoute,
    public taskService: TaskService,
    public router: Router,
    public sanitizer: DomSanitizer,
    public toastr: ToastrService,
    private formBuilder: FormBuilder,
    public requestService: RequestService,
    public activeRoute: ActivatedRoute,
    private expertService: ExpertService
  ) {
    super(route, taskService, router, sanitizer, toastr, activeRoute);
  }

  showRequest(data) {
    const request = this.requestService.createBolingPoint(data);
    this.post(request);
  }
}
